import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-exportar-flotante',
  templateUrl: './exportar-flotante.component.html',
  styleUrl: './exportar-flotante.component.scss',
  standalone: false
})
export class ExportarFlotanteComponent {
  @Output() limpiarFiltros = new EventEmitter<void>();
  @Output() limpiarDashboard = new EventEmitter<void>();

  exportar(){}

}
